import { parsePhoneNumberFromString } from 'libphonenumber-js';

export const isPhoneNumberValid = (phone: string) => {
  try {
    return parsePhoneNumberFromString(phone)?.isValid() ?? false;
  } catch {
    return false;
  }
};

export const isPhoneNumberLandline = (phone: string) => {
  try {
    return parsePhoneNumberFromString(phone)?.getType() === 'FIXED_LINE';
  } catch {
    return false;
  }
};

export function formatPhoneNumber(value: string) {
  try {
    return parsePhoneNumberFromString(value)?.formatInternational() ?? value;
  } catch {
    return value;
  }
}

/** E.164 (e.g. `+4741234567`) for API bodies. Undefined if not a valid international number. */
export function formatPhoneNumberAsE164(phone: string): string | undefined {
  const parsed = parsePhoneNumberFromString(phone);
  if (!parsed?.isValid()) {
    return undefined;
  }
  return parsed.format('E.164');
}
